module.exports = function() {
  return new Worker(__webpack_public_path__ + "25edb0020321e92c83ff.worker.js");
};